import { visitorId } from '~/composables/Misc'
import { Capacitor } from '@capacitor/core';
import VueMatomo from 'vue-matomo'

let isInit = false;

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    console.debug('[mat] loaded',useState('isConsentGiven').value)

    function methodHandle(val: any) {
      console.log('[mat] consent changed', val)

      if(!val || user.value?.is_admin) return;

      if (window?.location?.href.includes('localhost') && Capacitor.getPlatform() === 'web') {
        return
      }

      if (isInit) {
        console.debug('[mat] already initialized')
        return
      }

      isInit = true;

      console.debug('[mat] initializing Matomo', isInit)

      nuxtApp.vueApp.use(VueMatomo, {
        host: 'https://mat.blax.at',
        siteId: 6,
        router: nuxtApp.$router,
        enableLinkTracking: true,
        requireConsent: false,
        trackInitialView: true,
        disableCookies: true,
        requireCookieConsent: false,
        userId: visitorId(),
        enableHeartBeatTimer: true,
        heartBeatTimerInterval: 3,
        trackSiteSearch: true,
      })
    }

    watch(() => user, () => {
      const matomo = nuxtApp.vueApp.config.globalProperties.$matomo as any
      matomo.setUserId(visitorId())
    })

    // if url contains localhost
    watch(() => useState('isConsentGiven').value, methodHandle)
    methodHandle(useState('isConsentGiven').value)
  }
});
